<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>
    <div class="container py-3">
      <div class="row flex-nowrap mx-2 pt-3 justify-content-between align-items-center">
        <a href="https://www.chanchao.com.tw/en/">
          <div class="d-flex align-items-center">
            <div id="navLogo"></div>
            <div class="ml-2 logoText text-dark font-weight-nomal">
              <div>ChanChao Member</div>
            </div>
          </div>
        </a>

        <div class="d-flex ml-1">
          <a href="https://www.chanchao.com.tw/accounts/login">
            <img src="../../assets/images/langTW.svg" style="width: 17px; height: 17px" class="mb-1 mr-md-0 mr-2" />
            <span class="navEnText text-muted mr-3"> 中文版 </span>
          </a>

          <a href="https://www.chanchao.com.tw/accounts/vn/login">
            <img src="../../assets/images/vn.svg" style="width: 17px; height: 17px" class="mb-1" />
            <span class="navEnText text-muted ml-1"> Tiếng Việt </span>
          </a>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row formFrame m-1 py-2">
        <div class="lineRight col-md-7 my-4 px-4">
          <div class="d-flex align-items-center mb-4">
            <img src="../../assets/images/loginIcon.png" class="mr-2 mb-2" style="width: 40px; height: 40px" alt="" />
            <h4>Login</h4>
          </div>
          <form>
            <div class="form-group h6">
              <label for="loginEmail">Email</label>
              <input
                type="text"
                class="form-control"
                id="loginEmail"
                aria-describedby="emailHelp"
                name="email"
                maxlength="50"
                v-model="email"
                ref="loginEmail"
              />
            </div>
            <div class="form-group h6">
              <label for="loginPassword">Password</label>
              <div class="input-group mb-3">
                <input
                  type="password"
                  :type="typePwd"
                  class="form-control"
                  id="loginPassword"
                  name="password"
                  autocomplete="off"
                  maxlength="20"
                  :class="{ 'is-invalid': errors.first('password') }"
                  v-validate="'required'"
                  v-model="password"
                  ref="loginPassword"
                />

                <div class="input-group-append">
                  <span class="input-group-text" id="basic-addon2" @click.prevent="showPw">
                    <i class="fas fa-eye" v-if="typePwd == 'password'"></i>
                    <i class="fas fa-eye-slash" v-else="typePwd == 'text'"></i>
                  </span>
                </div>
              </div>
              <span class="text-danger" style="font-size: 10px" v-if="errors.first('password')"
                >The Password field is required
              </span>
            </div>
            <div class="form-group h6">
              <label for="loginPassword2">Verification Code</label>
              <div class="d-flex justify-content-around align-items-center">
                <input
                  type="text"
                  class="form-control mr-1"
                  id="loginPassword2"
                  name="text"
                  maxlength="5"
                  :class="{ 'is-invalid': errors.first('text') }"
                  v-validate="'required'"
                  v-model="Validcode"
                  ref="loginPassword2"
                />
                <img
                  :src="getsrc"
                  class="img-fluid rounded"
                  @click.prevent="resetValidcode"
                  style="width: 120px; height: 35px"
                />
                <a href="#" @click.prevent="resetValidcode">
                  <i class="ml-2 fas fa-redo" style="font-size: 25px"></i>
                </a>
              </div>
              <span class="text-danger" style="font-size: 10px" v-if="errors.first('text')"
                >The Verification field is required
              </span>
            </div>

            <div class="text-muted" style="font-size: 14px">
              By signing in to your account, you agree to our
              <a href="https://www.chanchao.com.tw/en/otherMember.asp" target="_blank"> Conditions of Membership</a>
            </div>

            <button type="submit" class="btn btn-block btn-primary mt-4" @click.prevent="loginBtn">Login</button>
          </form>

          <hr />
          <p>Login Problem?</p>
          <div class="linkFrame">
            <a href="https://www.chanchao.com.tw/accounts/en/forgetPw">Forgot Password</a>
            /

            <a href="https://www.chanchao.com.tw/en/contact.asp" target="_blank"> Contact us</a>
          </div>
        </div>

        <div class="col-md-5 my-4 px-4 lineBottom">
          <QAen />
        </div>
      </div>
    </div>

    <Footer />

    <router-view></router-view>
  </div>
</template>

<script>
  import QAen from '@/components/QA_en.vue'
  import Footer from '@/components/footer_en.vue'
  import $ from 'jquery'

  export default {
    metaInfo: {
      title: 'Login - Chan Chao Exhibition Hall',
    },
    components: {
      QAen,
      Footer,
    },

    data() {
      return {
        getsrc: '',
        isLoading: false,
        typePwd: 'password',

        email: '',
        password: '',
        Validcode: '',

        CSRF_Token: '',
        alertTitle: '',
        alertText: '',
        access_token: '',
        lastUrl: '',
      }
    },

    watch: {
      Validcode: function () {
        const vm = this
        vm.$refs.loginPassword2.style.borderColor = '#ced4da'
      },

      email: function () {
        const vm = this
        vm.$refs.loginEmail.style.borderColor = '#ced4da'
      },

      password: function () {
        const vm = this
        vm.$refs.loginPassword.style.borderColor = '#ced4da'
      },
    },

    methods: {
      resetValidcode() {
        const vm = this
        vm.$http.get('https://www.chanchao.com.tw/apiLogin/v1/Validcode').then((response) => {
          vm.getsrc = response.data
        })
      },

      loginBtn() {
        const vm = this
        const url = 'https://www.chanchao.com.tw/apiLogin/v1/Login'
        const info = {
          login: vm.email,
          password: vm.password,
          Validcode: vm.Validcode,
          CSRF: vm.CSRF_Token,
        }

        vm.$validator.validate().then((valid) => {
          if (valid) {
            vm.$http.post(url, info).then(function (response) {
              // // console.log(response)
              if (response.data == '200') {
                if (vm.lastUrl) {
                  // vm.$cookies.remove('CCURL')

                  window.location.replace(vm.lastUrl)
                } else {
                  // vm.$cookies.remove('CCURL')

                  window.location.replace('https://www.chanchao.com.tw/en') //不會發生
                }
              } else if (response.data == '252') {
                vm.alertText = 'Email error.'
                vm.alertError()
                vm.$refs.loginEmail.style.borderColor = 'red'
              } else if (response.data == '253') {
                vm.alertText = 'Password error.'
                vm.alertError()
                vm.$refs.loginPassword.style.borderColor = 'red'
              } else if (response.data == '254') {
                vm.alertText = 'Verification Code error.'
                vm.alertError()
                vm.$refs.loginPassword2.style.borderColor = 'red'
              } else if (response.data == '258') {
                vm.alertText = 'Please enable cookies on your browser and try to login again.'
                vm.alertError()
                vm.$refs.loginPassword2.style.borderColor = 'red'
              } else {
                vm.alertText = 'Server is busy, please try again later.'
                vm.alertError()
              }
            })
          } else {
            vm.alertText = 'Your request could not be completed.'
            vm.alertError()
          }
        })
      },

      alertError() {
        const vm = this
        vm.$swal({
          title: vm.alertTitle,
          text: vm.alertText,
          icon: 'info',
          confirmButtonText: 'OK',
          // animation: false,
          allowOutsideClick: true,
          confirmButtonColor: '#abc6d2',
          width: 300,
          padding: 15,
        })
      },

      showPw() {
        const vm = this
        vm.typePwd = vm.typePwd === 'password' ? 'text' : 'password'
      },
    },

    created() {
      const vm = this

      vm.$http.get('https://www.chanchao.com.tw/apiLogin/v1/Validcode').then((response) => {
        vm.getsrc = response.data
      })

      vm.$http.get('https://www.chanchao.com.tw/apiLogin/v1/CSRF_Token').then((response) => {
        vm.CSRF_Token = response.data
      })

      //GET LANDING PAGE

      let lastPage = document.referrer
      let domain = lastPage.split('/')[2]
      let noaccount = lastPage.split('/')[3] //排除account Url
      let domain_head = domain.split('.')[1].split('.')[0]

      if (lastPage && noaccount !== 'accounts') {
        if (domain == 'www.chanchao.com.tw' || domain_head == 'chanchao') {
          //如果網域為展昭

          vm.$cookies.set('url', lastPage, 60 * 60)
          vm.lastUrl = vm.$cookies.get('url')
        } else {
          vm.lastUrl = 'https://www.chanchao.com.tw/en' //如果不是展昭網域，就導回首頁
        }
      } else {
        if (vm.$cookies.get('url')) {
          vm.lastUrl = vm.$cookies.get('url')
        } else {
          vm.lastUrl = 'https://www.chanchao.com.tw/en'
        }
      }
      //更換英文語系

      vm.$i18n.locale = 'en'
    },
  }
</script>

<style lang="scss">
  //Swal setting
  .swal2-popup {
    font-size: 13px !important;
  }

  .swal2-styled.swal2-confirm {
    font-size: 12px;
  }

  #main-footer {
    bottom: 0;
  }

  .menuFrame {
    background-color: #f2f2f2;
    min-height: 100%;
  }

  .logoText {
    font-size: 20px;
  }

  #navLogo {
    width: auto;
    height: 55px;
    background-image: url(../../assets/images/ChanChaoLogo.png);
    background-repeat: no-repeat;
    background-position: left center;
    padding-left: 145px;
    background-size: auto 100%;
  }

  .formFrame {
    background-color: #ffffff;
    margin-top: 40px;
    border-radius: 10px;
    box-shadow: 1px 1px 1px 1px rgba(201, 199, 199, 0.5);
  }

  .lineRight {
    border-right: 1px solid #ccc;
  }

  .navEnText:hover {
    color: rgb(34, 34, 34) !important;
  }

  .navText {
    display: flex;
  }

  .input-note {
    font-size: 14px;
    color: rgb(190, 67, 67);
  }

  input::-webkit-input-placeholder {
    /* placeholder*/
    color: #aab2bd;
    font-size: 14px;
  }

  .linkFrame {
    font-size: 15px;
  }

  @media (max-width: 768px) {
    .lineRight {
      border-right: 0px;
    }

    .lineBottom {
      border-top: 0.5px solid rgb(230, 227, 227);
      padding-top: 30px;
    }

    .navEnText {
      display: none;
    }

    .navText {
      display: block;
    }

    .logoText {
      font-size: 16px;
    }
  }

  @media (max-width: 992px) {
    .auth-code {
      margin-top: 20px;
      margin-bottom: 20px;
    }
  }
</style>
